import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
// TODO: Import required services for Foreign Keys
import { ForwarderService } from '../proxy/general/controllers/forwarder.service';
import { SpeciesService } from '../proxy/general/controllers/species.service';
import { LengthService } from '@woodsupply/proxy/wood-supply/controllers/length.service';

FieldBuilder.setNamespace('General');

export const FORWARDERCAPACITY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('capacity', 'Entity.ForwarderCapacity.Capacity')
    .required()
    .build(),
  FieldBuilder
    .date('validSince', 'Entity.ForwarderCapacity.ValidSince')
    .required()
    .build(),
  FieldBuilder
    .foreignKey('speciesId', 'Entity.Species', SpeciesService)
    .displayFromNested('species.name')
    .sortBy('species.name')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('lengthId', 'Entity.Length', LengthService)
    .required()
    .display('value')
    .keyField('id')
    .build(),
  FieldBuilder
    .foreignKey('forwarderId', 'Entity.Forwarder', ForwarderService)
    .required()
    .displayFromNested('forwarder.name')
    .sortBy('forwarder.name')
    .hideInChildForms()
    .build(),
];

export const FORWARDERCAPACITY_CONFIG = {
  entityName: 'ForwarderCapacity',
  localizationKey: 'General::Entity.ForwarderCapacity',
  fields: FORWARDERCAPACITY_FIELDS,
  permission: 'GeneralMachinesAndVehicles.ForwarderCapacities',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
};
